<template>
    <div>
        <!-- Modals -->
        <TextModal :modalTitle="'Conditions d\'utilisation de ce service'"
                   :showModal.sync="showModal"
                   :modalText="getModalText"
                   modalClass="due-cgu"
        ></TextModal>
        <!-- Modals -->

        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success  mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="col-md-10 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="motif-due-border">
                                    <h2>Information des salariés</h2>
                                    <div v-if="legalInformation">
                                        <p v-for="(legalAdvice, index) in legalInformation.informationForEmployees.legalAdvice"
                                           :key="index"
                                           class="input-legend due-motifs-help-text"
                                        >{{ legalAdvice }}</p>
                                    </div>
                                </div>
                                <div class="motif-due-border motif-due-border-information">
                                    <h2>Garantie de conformité</h2>
                                    <p v-if="legalInformation"
                                       class="input-legend due-motifs-help-text"
                                    >{{ legalInformation.guaranteeOfConformity.legalAdvice }}</p>

                                </div>
                                <div class="form-group">
                                    <form
                                            name="exemption"
                                            method="post"
                                            enctype="multipart/form-data"
                                            novalidate="novalidate"
                                            class="needs-validation"
                                    >
                                        <!-- First Name -->
                                        <label class="required-field-asterisks required"
                                               for="legal_representative_first_name"
                                        >Prenom du representant de l'employeur</label>
                                        <input
                                                type="text"
                                                id="legal_representative_first_name"
                                                required="required"
                                                class="form-control form-control-lg"
                                                aria-describedby="first-name-error"
                                                :class="{ 'is-invalid': $v.formData.firstName.$error }"
                                                @input="delayTouch($v.formData.firstName)"
                                                placeholder="Prenom du representant de l'employeur"
                                                v-model="formData.firstName"
                                        >
                                        <FormError error="Veuillez renseigner le prénom"
                                                   v-if="$v.formData.firstName.$error"
                                        ></FormError>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.legalRepresentativeFirstName.legalAdvice }}</p>
                                        <!-- First Name -->

                                        <!-- Last Name -->
                                        <label class="required-field-asterisks required"
                                               for="legal_representative_last_name"
                                        >Nom du representant de l'employeur </label>
                                        <input
                                                type="text"
                                                id="legal_representative_last_name"
                                                required="required"
                                                class="form-control form-control-lg"
                                                aria-describedby="last-name-error"
                                                :class="{ 'is-invalid': $v.formData.lastName.$error }"
                                                @input="delayTouch($v.formData.lastName)"
                                                placeholder="Nom"
                                                v-model="formData.lastName"
                                        >
                                        <FormError error="Veuillez renseigner le nom"
                                                   v-if="$v.formData.lastName.$error"
                                        ></FormError>
                                        <p v-if="legalInformation"
                                            class="input-legend"
                                        >{{ legalInformation.legalRepresentativeLastName.legalAdvice }}</p>
                                        <!-- Last Name -->

                                        <!-- Email -->
                                        <label class="required-field-asterisks required"
                                               for="legal_representative_email"
                                        >Adresse email du representant de l'employeur</label>
                                        <input
                                                type="email"
                                                id="legal_representative_email"
                                                required="required"
                                                class="form-control form-control-lg"
                                                @input="delayTouch($v.formData.email)"
                                                placeholder="Email"
                                                v-model="formData.email"
                                        >
                                        <FormError error="Format de l'email incorrect"
                                                   v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                                        ></FormError>
                                        <FormError error="Veuillez renseigner l’email"
                                                   v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                                        ></FormError>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.legalRepresentativeEmail.legalAdvice }}</p>
                                        <!-- Email -->

                                        <!-- Agree to terms -->
                                        <div class="check-container">
                                            <div class="form-group clearfix">
                                                <div class="icheck-primary d-inline">
                                                    <input type="checkbox"
                                                           id="dueCheckbox"
                                                           v-model="formData.isPolicyAccepted"
                                                    >
                                                    <label for="dueCheckbox">
                                                        <span>J'ai lu et j'accepte les </span>
                                                        <a @click.prevent="handleOpenPopup"
                                                        >Conditions d'utilisation de ce service</a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Agree to terms -->

                                    </form>
                                </div>
                            </div>
                            <div class="col-md-4 col-xl-3 due-seventh-step-card">
                                <div class="info-card seventh-step-card-item">
                                    <span class="badge badge-danger">PDF</span>
                                    <h5 class="mt-2">
                                        <template v-if="Object.keys(due).length > 0 && due.collectiveAgreement.id === 54">
                                            <span v-text="`DUE neutre: ${ (due.collectiveAgreement.name).toLowerCase() }`"
                                            ></span>
                                        </template>

                                        <template v-else-if="Object.keys(due).length > 0">
                                            <span>DUE: </span>
                                            <span v-text="`${ due.collectiveAgreement.codeIdcc } ${ due.collectiveAgreement.name }`"
                                            ></span>
                                        </template>
                                    </h5>
                                    <div class="intro">Attention ce document n'a pas encore de valeur juridique</div>
                                    <img alt="" src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            :disabled="!due || downloadDueIsLoading"
                                            @click="downloadDuePdf()"
                                    >
                                        <span>Consulter</span>
                                        <ButtonSpinner :isLoading="downloadDueIsLoading"></ButtonSpinner>
                                    </button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.particularConditions"
                                >
                                    <h5 class="mt-2">Les conditions particulières</h5>
                                    <img alt="" src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('particularConditions')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.copyOfInformationNote"
                                    >
                                    <h5 class="mt-2">Copie de la notice d’information</h5>
                                    <img alt="" src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('copyOfInformationNote')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.particularConditionsForOptionalContract"
                                >
                                    <h5 class="mt-2">Les conditions particulières du contrat facultatif</h5>
                                    <img alt="" src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('particularConditionsForOptionalContract')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.copyOfInformationNoteForOptionalContract"
                                >
                                    <h5 class="mt-2">La notice d'information du contrat facultatif</h5>
                                    <img alt="" src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('copyOfInformationNoteForOptionalContract')"
                                    >Télécharger</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-lg btn-link btn__primary"
                                    :disabled="submitIsLoading || downloadDueIsLoading"
                                    @click.prevent="toPreviousStep('due-sixth-step')"
                            >
                                <span>Revenir à l'étape précédente</span>
                            </button>

                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="$v.$invalid || submitIsLoading || downloadDueIsLoading"
                                    @click.prevent="submit"
                            >
                                <span>Notifier le signataire</span>
                                <ButtonSpinner :isLoading="submitIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>

                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import DueSixthStepManager from '../../../service/manager/due/sixthStepManager';
    import DueDocumentManager from '../../../mixins/dueDocumentManager';
    import DueSeventhStepManager from '../../../service/manager/due/seventhStepManager';
    import FormError from '../../../components/FormError';
    import Header from '../../../components/Header';
    import TextModal from '../../../components/modal/TextModal';
    import { mapActions, mapGetters } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';
    import { dueSendUpdateLink } from '../../../service/api/dues.api';
    import {messageTexts, successMessage} from "@/utils/sweet-alert-options";
    import ScrollToMixin from "@/mixins/scrollToMixin";

    export default {
        mixins: [ValidationDelayTouch, DueStepsNavigation, DueDocumentManager, ScrollToMixin],
        data() {
            return {
                formData: {
                    particularConditions: null,
                    copyOfInformationNote: null,
                    particularConditionsForOptionalContract: null,
                    copyOfInformationNoteForOptionalContract: null,
                    firstName: '',
                    lastName: '',
                    email: '',
                    isPolicyAccepted: false
                },
                submitIsLoading: false,
                downloadDueIsLoading: false,
                showModal: false
            };
        },
        computed: {
            ...mapGetters({
                due: 'due',
                legalInformation: 'legalInformation'
            }),
            getModalText() {
                return this.legalInformation
                  ? this.legalInformation.dueGeneralConditionsOfUsageLegalAdviceText.legalAdvice
                  : null
                ;
            }
        },
        async mounted() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.setCurrentStep(7);
            this.scrollTo();
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueLegalInformation: 'fetchDueLegalInformation',
                clearDueData: 'clearDueData',
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                this.formData = {
                    ... this.formData,
                    ... await DueSixthStepManager.createFormDataFromResponse(this.due)
                };
            },
            async submit() {
                try {
                    this.submitIsLoading = true;
                    await dueSendUpdateLink(
                        this.due.id,
                        DueSeventhStepManager.createSeventhStepSubmitRequest(this.formData)
                    );

                    this.submitIsLoading = false;
                    await this.clearDueData();

                    this.$swal({ title: messageTexts.sendDueSuccess, ...successMessage });

                    await this.$router.push({ name: 'due-list'});
                } catch ({ response }) {
                    this.submitIsLoading = false;
                }
            },
            handleOpenPopup() {
                this.scrollTo();
                this.showModal = true;
            }
        },
        validations: {
            formData: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                email: {
                    required,
                    email
                },
                isPolicyAccepted: {
                    checked: (value) => {
                        return value === true;
                    }
                }
            }
        },
        components: {
            Header,
            Sidebar,
            Footer,
            ButtonSpinner,
            FormError,
            TextModal
        }
    }
</script>
